import React from 'react';
import Hero from "../components/Hero";
import styles from "../styles/cookies.module.css";

export default function Privacidad() {
    return (
        <main>
            <Hero subtitle="Política de Privacidad" />
        <section className={styles.contenido}>
          

            <h2>Responsable del tratamiento</h2>
            <p>
                <strong>Responsable:</strong> Fisioterapia Global Esport i Salut <br />
                <strong>Email de contacto:</strong> info@globalsportisalut.com
            </p>

            <h2>Finalidad del tratamiento de datos</h2>
            <p>
                Los datos personales proporcionados por los usuarios serán tratados con las siguientes finalidades:
            </p>
            <ul>
                <li>Gestionar las solicitudes de información realizadas a través del sitio web.</li>
                <li>Enviar comunicaciones comerciales relacionadas con los servicios ofrecidos (previo consentimiento).</li>
                <li>Mejorar la experiencia del usuario y la calidad de los servicios.</li>
            </ul>

            <h2>Legitimación</h2>
            <p>
                La base legal para el tratamiento de los datos es el consentimiento expreso del usuario al completar y enviar cualquier formulario de contacto o suscripción del sitio web.
            </p>

            <h2>Conservación de los datos</h2>
            <p>
                Los datos proporcionados se conservarán durante el tiempo necesario para cumplir con las finalidades descritas y mientras no se solicite su supresión por el interesado.
            </p>

            <h2>Destinatarios</h2>
            <p>
                No se cederán datos a terceros, salvo obligación legal o cuando sea necesario para la prestación de un servicio solicitado por el usuario.
            </p>

            <h2>Derechos del usuario</h2>
            <p>
                El usuario tiene derecho a:
            </p>
            <ul>
                <li>Acceder a sus datos personales.</li>
                <li>Solicitar la rectificación de datos inexactos.</li>
                <li>Solicitar la supresión de sus datos cuando ya no sean necesarios para los fines que fueron recogidos.</li>
                <li>Solicitar la limitación u oposición al tratamiento de sus datos.</li>
                <li>Solicitar la portabilidad de los datos.</li>
            </ul>
            <p>
                Para ejercer estos derechos, el usuario puede enviar una solicitud al correo electrónico: info@globalsportisalut.com
            </p>

            <h2>Medidas de seguridad</h2>
            <p>
                Fisioterapia Global Esport i Salut se compromete a adoptar las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
            </p>

            <h2>Modificaciones de la política de privacidad</h2>
            <p>
                La empresa se reserva el derecho de modificar esta política de privacidad para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria.
            </p>
            </section>
            </main>
    );
}
